import './InfoBanner.scss';

import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

type Props = {
  children: React.ReactNode;
  className?: string;
};

export default function InfoBanner ({ children, className }: Props) {
  return (
    <div className={`info-banner${className ? ` ${className}` : ''}`} role='note'>
      <InfoOutlinedIcon className='info-banner__icon' />
      <span>{children}</span>
    </div>
  );
}
